module.exports = __webpack_public_path__ + "img/inactive-9.3a54ad70.svg";